<div class="ups-dialog">
    <div class="dialog-header">
        <h2 mat-dialog-title>{{'disclaimerTitle'|translate}}</h2>
        <mat-dialog-actions>
        </mat-dialog-actions>
        <button type="button" mat-raised-button class="icon-button close-button" mat-dialog-close>
            <mat-icon>close</mat-icon>
        </button>
    </div>
    <div class="main-div">
        {{ 'disclaimerContent'|translate }}
    </div>
</div>